import React from 'react';
import RetentionSection from '../../../sections/AdminDashboard/Configuration/Retention';

const Retention = () => <RetentionSection />;

export default Retention;
